import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { USER_DATA_KEY } from '../../shared/constants/app.constants';
import { StorageService } from '../services/general-utils';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private storageService: StorageService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.storageService.getItem(USER_DATA_KEY)) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }

}
